// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"tomato"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 5.51353C12 5.51353 14.5559 4.75082 16 5.17556C18.8167 6.00402 20.9977 7.99784 21 12.5001C21.0022 17.0023 17.0176 21.7477 13.4433 20.9001C12.5412 20.6862 12.5756 20.601 12 20.601C11.4244 20.601 11.4587 20.6862 10.5567 20.9001C6.99996 21.7436 2.9997 16.9967 3 12.5001C3.0003 8.00353 5.1128 6.00081 7.99999 5.17556C9.44682 4.76202 12 5.51353 12 5.51353Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9.5 3L12 5.51343L14.6891 3M15.6487 5.68716L15.2973 6.19876C13.7081 8.51284 10.2919 8.51284 8.70268 6.19876L8.35134 5.68716M12 5.51353C12 5.51353 9.44682 4.76202 7.99999 5.17556C5.1128 6.00081 3.0003 8.00353 3 12.5001C2.9997 16.9967 6.99996 21.7436 10.5567 20.9001C11.4587 20.6862 11.4244 20.601 12 20.601C12.5756 20.601 12.5412 20.6862 13.4433 20.9001C17.0176 21.7477 21.0023 17.0023 21 12.5001C20.9977 7.99784 18.8167 6.00402 16 5.17556C14.5559 4.75082 12 5.51353 12 5.51353Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TomatoIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tomato',
    ref,
    icon: element,
  },
));

TomatoIcon.displayName = 'TomatoIcon';

export default TomatoIcon;
